module.exports = __webpack_public_path__ + "img/logoV.0c7bd272.png";